<div class="popups">
  @for (popup of popups; track popup.id) {
    <div class="popup">
      <ng-container
        *ngTemplateOutlet="popupTpl; context: { popup: popup }"></ng-container>
    </div>
  }
</div>

<ng-template #popupTpl let-popup="popup">
  <div [ngClass]="className(popup)">
    <div class="popup-header">
      <div class="popup-icon">
        <img
          [src]="src"
          class="badge-icon"
          matTooltipPosition="above"
          mat-raised-button
          matTooltip="{title}"
          matTooltipClass="customToolTip"
          [style]="{
            width: '20px'
          }" />
      </div>
      <div class="popup-title uppercase" id="pop-title">
        {{ popup.title }}
      </div>
    </div>

    <div class="popup-message">{{ popup.message }}</div>

    <button
      class="close-icon"
      (click)="close(popup)"
      matTooltip="Close the popup"
      matTooltipPosition="before">
      X
    </button>
  </div>
</ng-template>
